import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import Note from './Note';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const Notes = ({
  className,
  currentEmployee,
  isLoading,
  loadingIcon,
  notes,
  onSave,
  onRemove,
}) => {
  const [currentNotes, setCurrentNotes] = useState(notes || []);
  const [activeNoteId, setActiveNoteId] = useState(false);
  useEffect(() => setCurrentNotes(notes), [notes]);

  const cssBEM = 'notes-panel';
  const classes = classnames(cssBEM, className, {
    [`${cssBEM}--loading`]: isLoading,
  });

  const createNote = () => {
    const id = Math.random();
    setCurrentNotes([
      ...currentNotes,
      {
        id,
        content: '',
        isEditing: true,
        isNew: true,
      },
    ]);
    setActiveNoteId(id);
  };

  const editNote = (note) => {
    const updatedNote = {
      ...note,
      isEditing: true,
    };
    const updatedNotes = currentNotes.map((n) =>
      n.id === note.id ? updatedNote : n
    );
    setCurrentNotes(updatedNotes);
    setActiveNoteId(note.id);
  };

  const cancelNote = (note) => {
    const updatedNotes = note.isNew
      ? currentNotes.filter((n) => n.id !== note.id)
      : currentNotes;
    setCurrentNotes(updatedNotes);
    setActiveNoteId(false);
  };

  const saveNote = (note, value) => {
    const updatedNote = {
      ...note,
      content: value,
      isEditing: false,
      isNew: false,
      timestamp: new Date(),
    };
    const updatedNotes = currentNotes.map((n) =>
      n.id === note.id ? updatedNote : n
    );
    setCurrentNotes(updatedNotes);
    setActiveNoteId(false);

    if (onSave) {
      onSave({
        note: updatedNote,
        isNew: note.isNew,
        updatedNotes,
      });
    }
  };

  const removeNote = (note) => {
    const updatedNotes = currentNotes.filter((n) => n.id !== note.id);
    setCurrentNotes(updatedNotes);

    if (note.id === activeNoteId) {
      setActiveNoteId(false);
    }
    if (onRemove) {
      onRemove({ note, updatedNotes });
    }
  };

  const renderedLoadingIcon = (
    <div className="loading-notes-icon">
      {loadingIcon ? (
        loadingIcon
      ) : (
        <FormattedMessage id="notes.panel.isLoading" />
      )}
    </div>
  );

  const renderedNotes = currentNotes.map((n) => {
    return (
      <Note
        currentEmployee={currentEmployee}
        isLoading={isLoading}
        note={n}
        key={n.id}
        onCancel={cancelNote}
        onSave={saveNote}
        onEdit={editNote}
        onRemove={removeNote}
        editMode={n.id === activeNoteId}
        disableMode={activeNoteId && n.id !== activeNoteId}
      />
    );
  });

  return (
    <div className={classes}>
      {renderedNotes.length ? (
        renderedNotes
      ) : (
        <div className={`${cssBEM}__isEmpty`}>
          <FormattedMessage id="notes.panel.isEmpty" />
        </div>
      )}
      <div className={`${cssBEM}__actions`}>
        {isLoading ? (
          renderedLoadingIcon
        ) : (
          <button onClick={createNote} className={`${cssBEM}__addButton`}>
            <FormattedMessage id="notes.panel.add" />
          </button>
        )}
      </div>
    </div>
  );
};

Notes.propTypes = {
  className: PropTypes.string,
  currentEmployee: PropTypes.any,
  isLoading: PropTypes.bool,
  loadingIcon: PropTypes.any,
  locale: PropTypes.string,
  notes: PropTypes.array,
  onSave: PropTypes.func,
  onRemove: PropTypes.func,
};

export default Notes;
